<template>
  <el-dialog
    title="导出统计"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form
        :inline="true"
        label-position="left"
        class="demo-form-inline"
        :model="form"
        :rules="rules"
        ref="demoref"
      >
        <el-form-item label="导出时间统计" prop="valueTime">
          <el-date-picker
            v-model="form.valueTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        @click="addOrUpdateFun()"
        :loading="exportLoading"
        >导 出</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { ksSubmitListExp } from "@/api/task.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        valueTime: null
      },
      rules: {
        valueTime: [
          { required: true, message: "请选择导出时间统计", trigger: "change" }
        ]
      },
      exportLoading: false
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    addOrUpdateFun() {
      this.$refs.demoref.validate(async valid => {
        if (valid) {
          this.exportLoading = true;
          let res = await ksSubmitListExp({
            timeStr: this.form.valueTime
          });
          if (res.status == 200) {
            this.exportLoading = false;
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${this.form.valueTime}科室提交导出.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            this.$emit("update:dialogVisible", false);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 10px 20px;
}

/deep/.el-input {
  width: auto !important;
}
/deep/.el-dialog {
  margin-top: 16vh !important;
}
.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/longInspectionTask/components/exportDialog.vue